import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

/** Sends logged-out visitors to /login, remembering where they were going. `staff` also requires a staff account. */
const RequireAuth: React.FC<{ children: React.ReactElement; staff?: boolean }> = ({ children, staff = false }) => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  if (isLoading) return null;
  if (!isAuthenticated) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  if (staff && !user?.isStaff) return <Navigate to="/" replace />;
  return children;
};

export default RequireAuth;
